import { httpClient } from "../utils/HttpClient";

const getAll = (page_no, filter_name) => {
  return httpClient.get("/admin/channel", {
    params: {
      page: page_no,
      name: filter_name,
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

const get = (channel_id) => {
  return httpClient.get(`/admin/channel/${channel_id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

const getChannelNameSelect = () => {
  return httpClient.get(`/admin/channel_select`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

const getChannelNameAddSelect = () => {
  return httpClient.get(`/admin/channel_add`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

const create = (data) => {
  return httpClient.post("/admin/channel", data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

const update = (channel_id, data) => {
  return httpClient.patch(`/admin/channel/${channel_id}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

const remove = (channel_id) => {
  return httpClient.delete(`/admin/channel/${channel_id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

const updateStatus = (channel_id, data) => {
  return httpClient.patch(`/admin/channel/status/${channel_id}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
};

export default {
  getAll,
  get,
  create,
  update,
  remove,
  updateStatus,
  getChannelNameSelect,
  getChannelNameAddSelect
};
